import { cn } from './chunk-FFX3LZW7.js';
import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { jsx } from 'react/jsx-runtime';

var TooltipProvider = TooltipPrimitive.Provider;
var Tooltip = TooltipPrimitive.Root;
var TooltipTrigger = TooltipPrimitive.Trigger;
var TooltipContent = React.forwardRef(function TooltipContent2({ className, sideOffset = 4, ...props }, ref) {
  return /* @__PURE__ */ jsx(TooltipPrimitive.Portal, { children: /* @__PURE__ */ jsx(
    TooltipPrimitive.Content,
    {
      ref,
      sideOffset,
      className: cn(
        "z-50 overflow-hidden rounded-md bg-primary px-3 py-1.5 text-xs text-primary-foreground animate-in fade-in-0 zoom-in-95",
        className
      ),
      ...props
    }
  ) });
});

export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };
//# sourceMappingURL=chunk-ZYE4SVUO.js.map
//# sourceMappingURL=chunk-ZYE4SVUO.js.map